<!--  crud table -->
<template>
  <v-container grid-list-md id="VIDEO">
    <!-- api 호출등 화면의 락을 건다.-->
    <v-overlay :value="loading" :absolute="true">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <!-- card header -->
      <v-toolbar flat dense>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="newItem" :disabled="loading">
          <v-icon>mdi-plus-circle-outline</v-icon>
        </v-btn>
        <v-btn icon @click="list" :disabled="loading">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider class="mt-0"></v-divider>

      <v-text-field
        label="Search Text"
        color="primary"
        single-line
        clearable
        v-model="searchText"
        style="margin-left: 20px; margin-right: 20px"
      >
        <template v-slot:append>
          <v-btn depressed tile color="primary" class="ma-0">SEARCH</v-btn>
        </template>
      </v-text-field>

      <v-card-text class="pa-4">
        <!-- 내용 -->
        <v-data-table
          :headers="headers"
          :items="rows"
          hide-default-footer
          :loading="loading"
          dense1
          class="elevation-1 ma-0"
        >
          <!-- 2.xx version 부터 items 가 사라졌다.
          v-slot:item.<name>  을 사용할수 없어서  모든 item을  iteratiion 한다.
          -->
          <template v-slot:item="props">
            <tr class="clickable-row ma-0" style="height: 12">
              <template v-for="(header, index) in headers">
                <!--  button Action -->
                <td v-if="header.type == 'button'" :key="index">
                  <v-chip
                    fab
                    dark
                    small
                    color="primary"
                    @click="buttonClick(header.name, props.item)"
                  >
                    <v-icon dark> {{ header.icon }} </v-icon>
                  </v-chip>
                </td>
                <td v-else-if="header.type == 'action'" :key="index">
                  <v-icon small class="mr-2" @click="detailItem(props.item)"
                    >mdi-eye</v-icon
                  >
                  <v-icon small @click="deleteItem(props.item)">delete</v-icon>
                </td>
                <td v-else-if="header.type == 'chip'" :key="index">
                  <v-chip
                    label
                    :color="getColor(props.item[header.value])"
                    dark
                  >
                    {{ props.item[header.value] }}
                  </v-chip>
                </td>
                <td v-else :key="index">
                  {{ props.item[header.value] | dataFilter(header) }}
                </td>
              </template>
            </tr>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            v-model="page"
            :length="totalPage"
            @input="input"
            :total-visible="9"
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
    <v-dialog v-model="deleteDlg" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Delete Selected Item?</v-card-title>
        <v-card-text>
          Item Uid :
          <b>{{ sendKey }}</b>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="green darken-1" text @click="deleteDlg = false"
            >Cancel</v-btn
          >
          <v-btn color="green darken-1" text @click="deleteConfirmed"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <unicon name="times-circle" @click="closeHide" width="45" height="45">
      </unicon>
      <div class="player-container">
        <vue-core-video-player
          :core="HLSCore"
          :src="playUrl"
          ref="player"
        ></vue-core-video-player>
      </div>
    </v-overlay>
  </v-container>
</template>

<script>
/**
 * Table
 * 호춯 순서.
 * created...
 *
 *   params 의 객체명 과 page 값을 가지고 온다. (인자가 없으면 1)
 *
 *
 *
 */
import _ from "lodash";
import crud_util from "../crud/crud_util";
import HLSCore from "@core-player/playcore-hls";

import { AdminAPI } from "@/api";
export default {
  data() {
    return {
      searchText: null,
      page: 1, // current page
      totalPage: 1, // total page
      totalCount: 0, // item count
      itemsPerPage: 10, // items per page  in table
      loading: false, // block ui
      options: null, // search optiuon
      objNm: null, // current objNm
      sendKey: null,

      headers: [], // header item
      page: 0,
      rows: [],
      title: "",
      objInfo: null,
      deleteDlg: false,
      overlay: false,
      playUrl: "",
      HLSCore,
    };
  },
  computed: {
    objCls() {
      return this.objNm.toLowerCase();
    },
  },
  //page created
  created() {
    this.initialize();
  },
  // data filter
  filters: {
    dataFilter: crud_util.dataFilter,
  },
  watch: {
    $route(to, from) {
      // 뷰의 이름이 같고 객체의 이름이 다른경우...
      if (
        to.name === from.name &&
        to.params &&
        to.params.objNm !== this.objNm
      ) {
        this.initialize();
      } else if (
        to.name === from.name &&
        to.params &&
        to.params.objNm == this.objNm &&
        to.params &&
        to.params.page != from.params.page
      ) {
        this.page = Number(to.params.page); // change current page
        this.goto(to.params.page);
      }
    },
    objInfo(objInfo, b) {
      console.log("objInfo change");
      this.makeHeader(objInfo);
    },
  },
  methods: {
    closeHide() {
      console.log("CloseHide");
      this.playUrl = "";
      console.log(this.$refs.player);

      this.overlay = !this.overlay;
    },
    getColor(value) {
      console.log("value...", value);
      if (value == "ok" || value == "connected") return "green";
      else return "red";
    },
    buttonClick(name, value) {
      console.log(name, value);
      if (name == "live") {
        this.playUrl = `https://s3.ap-northeast-2.amazonaws.com/s3.iandrive.com${value.obj_path}/live_${value.m3u}`;
      } else {
        this.playUrl = `https://s3.ap-northeast-2.amazonaws.com/s3.iandrive.com${value.obj_path}/${value.m3u}`;
      }
      this.overlay = true;
    },
    // create 이후 초기화
    async initialize() {
      console.log("#2 initiallize");
      this.objNm = this.$route.params.objNm;
      this.page = this.$route.params.page ? Number(this.$route.params.page) : 1;
      // this.headers = [];

      this.rows = [];
      this.loading = true;
      //  정보를 가지고 온다.
      try {
        await this.$store.dispatch("admin/objInfo", this.objNm);

        await this.makeTable();
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
      this.goto(this.page);
    },
    /**
     * create table
     */
    async makeTable() {
      let info = this.$store.state.admin.objInfo;
      await this.makeHeader(info);
      this.list();
    },
    /**
     *
     * 테이블 헤더 만들기
     */
    async makeHeader(info) {
      let headers = [];

      _.each(info.fields, (item) => {
        if (item.hide || item.hideList) return;
        let header = {
          text: item.dispName
            ? item.dispName
            : item.text
            ? item.text
            : item.key,
          value: item.key,
          name: item.name,
          type: item.type,
          chip: item.chip,
          sortable: false,
          icon: item.icon,
          align: "left", //'center'
        };

        headers.push(header);
      });
      headers.push({ text: "", type: "action", value: "action" });
      this.headers = headers;
      this.search_field = headers.length > 0 ? headers[0].value : "";
    },

    /**
     * 데이타 요청
     * crud.list 의 요청의 결과로 건수가 함께 되돌려진다.
     * 되돌려진 자료는  state의 rows 와 count 에 저장된다.
     *
     */

    async list() {
      this.loading = true;
      try {
        await this.$store.dispatch("admin/list", {
          objNm: this.objNm,
          page: this.page,
          perpage: this.itemsPerPage,
        });
        this.rows = this.$store.state.admin.rows[this.objNm];

        this.totalPage = Math.ceil(
          this.$store.state.admin.count[this.objNm] / this.itemsPerPage
        );

        this.title = this.$store.state.admin.objInfo.title;
      } finally {
        this.loading = false;
      }
    },
    /**
     * page 이동
     */
    goto(page) {
      if (this.$route.params.page == page) {
        return;
      }
      this.$route.params.page = page;
      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
      });
      if (this.loading) return;
      this.list();
    },
    /**
     * page 이동.
     */
    input(data) {
      this.goto(data);
    },
    async newItem() {
      this.$router.push({
        name: "newObj",
        params: {
          objNm: this.objNm,
        },
      });
    },
    async detailItem(item) {
      let info = this.$store.state.admin.objInfo;

      let sendKey = item[info.uid];
      console.log(item, info.uid, sendKey);
      this.$router.push({
        name: "detailObj",
        params: {
          objNm: this.objNm,
          uid: sendKey,
        },
      });
    },
    async editItem(item) {
      let info = this.$store.state.admin.objInfo;
      let sendKey = item[info.uid];
      this.$router.push({
        name: "editObj",
        params: {
          objNm: this.objNm,
          uid: sendKey,
        },
      });
    },
    async deleteItem(item) {
      let info = this.$store.state.admin.objInfo;
      let sendKey = item[info.uid];
      this.sendKey = sendKey;

      this.deleteDlg = true;
    },
    async deleteConfirmed() {
      this.loading = true;
      this.deleteDlg = false;
      let sendKey = this.sendKey;
      this.sendKey = null;
      try {
        let r = await AdminAPI.delete({ objNm: this.objNm, uid: sendKey });
        console.log("delete", r);
        await this.list();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style>
#VIDEO .v-overlay__content {
  width: 100%;
  height: 100%;
}
#VIDEO .v-overlay__content .unicon {
  position: absolute;
  z-index: 99;
}
.unicon {
  fill: #ffffff;
  stroke: rgba(0, 0, 0, 0.5);
  vertical-align: middle;
  top: 10px;
  left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/etc/video.vue